/**
 * Declarative registry of opt-in experimental features for Portfolio
 * Analysis. The PreferencesDialog reads this list to render switches in the
 * "Experimental Features" section (visible only when the
 * `portfolio_analysis_experimental` BFF policy passes), and consumer code
 * uses `useExperimentalFeature(key)` to check whether a given feature is
 * both available (policy) and opted-in (preferences).
 *
 * Adding a new experimental feature:
 *   1. Append an entry here with a unique `key`, user-facing `label`, and
 *      optional `description`.
 *   2. Add a matching default to `DEFAULT_PREFERENCES.experimental` in
 *      lib/preferencesStorage.js (e.g. `scopeFilters: false`) so the form
 *      and "Reset to defaults" pick it up automatically.
 *   3. In the consuming component, drive UI off
 *      `useExperimentalFeature('yourKey', prefs)`.
 *
 * Each entry shape:
 *   {
 *     key: string,            // matches the preferences sub-key
 *     label: string,          // shown next to the toggle
 *     description?: string    // optional helper text under the row
 *   }
 */
export const EXPERIMENTAL_FEATURES = [
  {
    key: 'scopeFilters',
    label: 'Server-side scope filters',
    description: 'Add row filters to grouping levels. Filters affect calculations and rollups above the level.'
  }
]
